import { Component, h } from 'preact'
import axios from 'axios'
import Header from '../header'
import IdeationList from './IdeationList'
import IdeationAddEdit from './IdeationAddEdit'
import Modal from '../../components/reactModal'
import ConfirmationModal from '../ui-components/ConfirmationModal'
import AlertComponent from '../ui-components/AlertComponent'

type Endpoints = {
  getIdeations: string,
  setIdeation: string,
  deleteIdeation: string
}

type Ideation = {
  bgColor: string,
  context?: string,
  default?: boolean,
  id?: number,
  index?: number,
  name: string,
  textColor: string
}

interface Props {}

interface State {
  list: Array<Ideation>,
  newIdeation: Ideation,
  editableIdeationData: Ideation | null,
  showModal: boolean,
  showConfirmation: boolean,
  isLoading: boolean,
  showError: boolean,
  messageType: string | null,
  message: string,
  deleteItem: number | null
}

function isIdeation (whatever: Ideation | null): whatever is Ideation {
  return !!whatever
}

class IdeationContainer extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      list: [],
      newIdeation: {
        name: '',
        bgColor: '#000',
        textColor: '#fff'
      },
      editableIdeationData: null,
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      deleteItem: null,
      messageType: null,
      message: ''
    }

    this.endpoints = {
      getIdeations: '/settings/ideation/_getstatuses',
      setIdeation: '/settings/ideation/updateStatus',
      deleteIdeation: '/settings/ideation/deleteStatus'
    }

    this.enableModal = this.enableModal.bind(this)
    this.saveIdeation = this.saveIdeation.bind(this)
    this.updateIdeation = this.updateIdeation.bind(this)
    this.shouldDeleteIdeation = this.shouldDeleteIdeation.bind(this)
    this.deleteIdeation = this.deleteIdeation.bind(this)
  }

  endpoints: Endpoints

  async componentDidMount () {
    const { data } = await axios.get(this.endpoints.getIdeations)
    if (!data.length) {
      return
    }
    data.forEach((item: Ideation) => {
      item.bgColor = `#${item.bgColor}`
      item.textColor = `#${item.textColor}`
    })

    this.setState({ list: data, newIdeation: Object.assign({}, this.state.newIdeation, { bgColor: data[0].bgColor }) })
  }

  async saveIdeation () {
    let newData = this.state.editableIdeationData
    if (isIdeation(this.state.editableIdeationData)) {
      newData = Object.assign({}, this.state.editableIdeationData, {
        bgColor: this.state.editableIdeationData.bgColor.substr(1),
        textColor:  this.state.editableIdeationData.textColor.substr(1)
      })
    }


    this.setState({ isLoading: true, showError: false, messageType: null, message: '' })
    try {
      const { data } = await axios.post(this.endpoints.setIdeation, { ...newData })
      let updatedList = this.state.list
      if (this.state.editableIdeationData && typeof(this.state.editableIdeationData.index) === 'number') {
        updatedList[this.state.editableIdeationData.index] = Object.assign({}, this.state.editableIdeationData, data)
      }
      this.setState({ list: updatedList,
        showModal: false,
        isLoading: false,
        message: newData && newData.id ? 'All changes saved!' : 'A new ideation is added successfully!',
        messageType: 'success'
      })
    } catch (e) {
      this.setState({ isLoading: false, showError: true })
    }
  }

  enableModal (item: Ideation, idx: number) {
    this.setState({ editableIdeationData: Object.assign({}, item, { index: idx }),
      showModal: true,
      message: '',
      messageType: null
    })
  }

  updateIdeation (newData: Ideation) {
    this.setState({ editableIdeationData: newData })
  }

  shouldDeleteIdeation (idx: number) {
    this.setState({ showConfirmation: true, deleteItem: idx })
  }

  async deleteIdeation () {
    if (typeof this.state.deleteItem !== 'number') {
      return
    }

    this.setState({ isLoading: true, showError: false, messageType: null, message: '' })

    const idx: number = this.state.deleteItem
    let updatedList = this.state.list.slice()
    updatedList.splice(idx, 1)

    if (idx <= this.state.list.length) {
      try {
        await axios.post(this.endpoints.deleteIdeation, { id: this.state.list[idx].id })
        this.setState({ list: updatedList,
          showConfirmation: false,
          isLoading: false,
          message: 'An ideation status is deleted',
          messageType: 'success'
        })
      } catch (e) {
        this.setState({ isLoading: false, showError: true })
        console.log(e)
      }
    } else {
      this.setState({ list: updatedList, showConfirmation: false })
    }
  }

  render (props: Props,
          { list, newIdeation, showModal, editableIdeationData,
            isLoading, showError, showConfirmation, deleteItem, messageType, message }: State) {
    const colors = list.reduce((allColors: Array<string>, item) => { if (item.bgColor && allColors.indexOf(item.bgColor) === -1) { allColors.push(item.bgColor) } return allColors }, [])

    return (
      <div className='ideation-page_container'>
        <Header title='Ideation Status' disableCancelButton disableSaveButton />
        { messageType ? <AlertComponent message={message} messageType={messageType} isVisibleFor={3000} /> : null }
        <IdeationList deleteCallback={this.shouldDeleteIdeation} list={list} colors={colors} openEditIdeationModal={this.enableModal} />
        <div className='ideation-add-trigger-button'>
          <button className='btn btn-primary' onClick={() => this.enableModal(this.state.newIdeation, list.length)}>Add new status</button>
        </div>
        <Modal isOpen={showModal} onClose={() => this.setState({ showModal: false, showError: false })}>
          <IdeationAddEdit
            title={editableIdeationData && editableIdeationData.index === list.length ? 'Add new status' : 'Edit status'}
            data={editableIdeationData}
            colors={colors}
            onCallback={this.updateIdeation}
            cancelCallback={() => { this.setState({ showModal: false, showError: false }) }}
            isLoading={isLoading}
            showError={showError}
            saveCallback={this.saveIdeation}
          />
        </Modal>
        <ConfirmationModal
          isLoading={isLoading}
          showError={showError}
          enableModal={showConfirmation}
          title={deleteItem ? `Delete this ideation status '${list[deleteItem] && list[deleteItem].name}'?` : ''}
          message={'All ideas with this status will lose their status.'}
          onClose={() => { this.setState({ showConfirmation: false, showError: false }) }}
          buttons={[
            {
              text: 'Delete',
              callback: this.deleteIdeation,
              class: 'btn btn-danger',
              showLoading: true
            },
            {
              text: 'Cancel',
              callback: () => { this.setState({ showConfirmation: false, showError: false }) },
              class: 'btn btn-default',
              showLoading: false
            }
          ]}
        />
      </div>
    )
  }
}

export default IdeationContainer
